"use strict";
var DateRange = (function () {
    function DateRange(from, to) {
        this.from = from;
        this.to = to;
        this.from = from;
        this.to = to;
    }
    Object.defineProperty(DateRange.prototype, "isValid", {
        get: function () {
            return this.to >= this.from;
        },
        enumerable: true,
        configurable: true
    });
    return DateRange;
}());
exports.DateRange = DateRange;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-material-components/models/date-range.js
// module id = 38
// module chunks = 0